export default [{
    path: '/account/:trigger?',
    name: 'account',
    component: () => import('./containers/account/index'),
}, {
    path: '/checkout/:priceId',
    name: 'checkout',
    component: () => import('./containers/checkout/index'),
},{
    path: '/receipts',
    name: 'receipts',
    component: () => import('./containers/Receipts'),
}, {
    path: '/payment-failed',
    name: 'payment-failed',
    component: () => import('./containers/payment-failed'),
}, {
    path: '/startup-profile',
    name: 'startup-profile',
    component: () => import('./containers/startup-profile/index'),
}, {
    path: '/investor-profile',
    name: 'investor-profile',
    component: () => import('./containers/investor-profile/index'),
},];
